import React, {useState} from "react";
import intl from "react-intl-universal";
import {observer} from "mobx-react-lite";
import classNames from "classnames";
import {useAppState, useUserState} from "@stores/AppStateContext";

import {DummyBox} from "../../components/Dummy/DummyBox";
import {UserAvatar} from "../../components/Avatar/Avatar";
import {Tooltip} from "../../components/Tooltip"

import {screenSizeProvider} from "../../../stores/ScreenSizeProvider";

import './ProfileIcon.css';

export interface ProfileIconProps {
    className?: string;
    size?: number;
    onlyLogout?: boolean;
}

export const ProfileIcon = observer((
    {
        className,
        size,
        onlyLogout = false,
    }: ProfileIconProps
) => {
    const appState = useAppState();
    const userState = appState.userState;
    const isMobile = screenSizeProvider.view !== 'desktop';
    const [isProfileClicked, setProfileClicked] = useState(false);

    const isReady = userState?.currentUserDb;
    const avatarSize = size ?? (isMobile ? 40 : 24);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        if (!isReady) {
            return;
        }

        event.stopPropagation();
        if (isProfileClicked) {
            appState.setContextMenu(null);
        } else {
            setProfileClicked(true);
            const targetDom = event.currentTarget;
            appState.addAdditionalContextMenu({
                clientX: event.clientX,
                clientY: event.clientY,
                type: 'profile',
                id: 'unique',
                withOverlay: true,
                menuPlacement: 'block-end',
                menuAlignment: 'center',
                withPointer: true,
                shouldForcePlace: true,
                getTargetBoundingBox: () => targetDom.getBoundingClientRect(),
                params: {
                    onlyLogout: onlyLogout
                },
                onClose: () => {
                    setProfileClicked(false);
                },
            });
        }
    };

    return (
        <div className={classNames('ProfileIcon', {
            [className!]: className,
        })}
             onClick={handleClick}
        >
            {
                (!isReady)
                    ? <DummyBox type={'circle'}
                                width={`${avatarSize}px`} height={`${avatarSize}px`}/>
                    : (
                        <Tooltip
                            title={intl.get('tooltip.HeaderRightPart.accountSettings').d("Account Settings")}
                            menuPlacement={"block-end"}
                            menuAlignment={"end"}
                        >
                            <UserAvatar
                                className='HeaderRightPart__profile'
                                size={42}
                                user={userState!.currentUserDb!}
                                presignedUrl={userState!.currentUserAvatarSrc}
                            />
                        </Tooltip>
                    )
            }
        </div>
    )
})
